import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  readonly loading = signal<boolean>(false);

  /**
   * Shows the loading overlay
   */
  show(): void {
    this.loading.set(true);
  }

  /**
   * Hides the loading overlay
   */
  hide(): void {
    this.loading.set(false);
  }
}
